import axios from 'axios'
import * as utils from 'src/apis/apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/masters/poles'), {
      params: params || {}
    })
  },
  import(params) {
    return axios.post(utils.getApiUrl('/masters/poles/import'), params)
  },
}
